<template>
	<div>
		<div v-for="(item, i) in config.options" :key="i" v-show="currentGroup == item.value">
			<div v-if="item.content" :class="{'edit-group': config.groupStyle !== false}">
				<unit-edit-form ref="form" :config="item.content"></unit-edit-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			unitEditForm: () => import('./unit_edit_form.vue')
		},
		
		props: {
			currentGroup: [String, Number],
			config: Object
		},
		
		data() {
			return {
			}
		},
		
		methods: {
			set(data) {
				this.$refs.form && this.$refs.form.forEach(item => {
					item.set(data);
				});
			},
			
			submit: async function() {
				let data = {};
				for (let i = 0; i < this.$refs.form.length; i++) {
					let temp = await this.$refs.form[i].submit();
					data = Object.assign(data, temp);
				};
				return data
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.edit-group {
		border: 1px solid #ddd;
		padding: 16px 20px 0;
		margin: -10px 0 16px;
		background: #F8F8F8;
	}
</style>
